// extracted by mini-css-extract-plugin
module.exports = {"container":"CropPhoto_container__2FpYw","svg":"CropPhoto_svg__3UirU","zoomContainer":"CropPhoto_zoomContainer__1QFaL"};